var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBarChartEqual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 14C14.75 14.4142 14.4142 14.75 14 14.75L11.3333 14.75C10.9191 14.75 10.5833 14.4142 10.5833 14L10.5833 2C10.5833 1.58579 10.9191 1.25 11.3333 1.25L14 1.25C14.4142 1.25 14.75 1.58579 14.75 2L14.75 14ZM13.25 13.25L13.25 2.75L12.0833 2.75L12.0833 13.25L13.25 13.25Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0835 14.0002C10.0835 14.4145 9.74771 14.7502 9.3335 14.7502L6.66683 14.7502C6.25262 14.7502 5.91683 14.4145 5.91683 14.0002L5.91683 2.00024C5.91683 1.58603 6.25262 1.25024 6.66683 1.25024L9.3335 1.25024C9.74771 1.25024 10.0835 1.58603 10.0835 2.00024L10.0835 14.0002ZM8.5835 13.2502L8.5835 2.75024L7.41683 2.75024L7.41683 13.2502L8.5835 13.2502Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4165 14C5.4165 14.4142 5.08072 14.75 4.6665 14.75L1.99984 14.75C1.58562 14.75 1.24984 14.4142 1.24984 14L1.24984 2C1.24984 1.58579 1.58562 1.25 1.99984 1.25L4.6665 1.25C5.08072 1.25 5.4165 1.58579 5.4165 2L5.4165 14ZM3.9165 13.25L3.9165 2.75L2.74984 2.75L2.74984 13.25L3.9165 13.25Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarChartEqual);
export default __webpack_public_path__ + "static/media/icon-bar-chart-equal.54501bcaddd39199dc15261d373dfa73.svg";
export { ForwardRef as ReactComponent };